import { render, staticRenderFns } from "./CustomDataTable.vue?vue&type=template&id=134016e4&scoped=true&"
import script from "./CustomDataTable.vue?vue&type=script&lang=js&"
export * from "./CustomDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomDataTable.vue?vue&type=style&index=0&id=134016e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134016e4",
  null
  
)

export default component.exports